'use strict';

var Link = require('../Link');
var getMarketplaceData = require('../../models/marketplace-urls');

function renderMarketplaceLinks(depsArg) {
	var marketplaceData = getMarketplaceData.getMarketplaceData(depsArg);
	var _ = depsArg.underscore;

	return {

		renderHomeLink: function render(config, deps) {
			return (new Link({
				isVisible: true,
				labelRaw: 'Marketplace',
				urlSource: marketplaceData.getHomeUrl(),
				id: 'shop' // for MyAppsController.js
			})).render(config, deps);
		},

		renderLogInLink: function render(config, deps) {
			return (new Link({
				isVisible: true,
				labelRaw: 'sign.in',
				urlSource: marketplaceData.getLogInUrl()
			})).render(config, deps);
		},

		renderLogOutLink: function render(config, deps) {
			return (new Link({
				isVisible: true,
				labelRaw: 'logout',
				urlSource: marketplaceData.getLogOutUrl()
			})).render(config, deps);
		},

		renderMyAppsLink: function render(config, deps) {
			var channel = config.CHANNEL_SETTINGS || {};

			return (new Link({
				isVisible: _.contains(channel.capabilities, 'CUSTOMER_APPLICATION_MANAGEMENT'),
				labelRaw: 'My.Apps',
				urlSource: marketplaceData.getMyAppsUrl(),
				id: 'myapps' // For MyAppsController.js
			})).render(config, deps);
		},

		renderSignUpLink: function render(config, deps) {
			var channel = config.CHANNEL_SETTINGS || {};

			return (new Link({
				isVisible: !channel.hideSignupLinks,
				labelRaw: 'sign.up',
				urlSource: marketplaceData.getSignUpUrl()
			})).render(config, deps);
		}
	};
}

module.exports = {
	renderMarketplaceLinks: renderMarketplaceLinks
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/links/marketplace-links.js
// module id = 11
// module chunks = 0